import React from 'react';
import { View, StyleSheet, TouchableOpacity, Linking, StyleProp, ViewStyle } from 'react-native';
import { Text } from 'react-native-paper';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { colors, spacing, typography } from '../constants/theme';

interface HelpfulLink {
  url: string;
  label: string;
}

interface HelpfulLinksDisplayProps {
  label: string;
  links: HelpfulLink[];
  style?: StyleProp<ViewStyle>;
}

const HelpfulLinksDisplay: React.FC<HelpfulLinksDisplayProps> = ({
  label,
  links,
  style,
}) => {
  const handleLinkPress = async (url: string) => {
    // Validate URL
    let finalUrl = url;
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      finalUrl = 'https://' + url;
    }

    try {
      const supported = await Linking.canOpenURL(finalUrl);
      if (supported) {
        await Linking.openURL(finalUrl);
      } else {
        console.warn(`Cannot open URL: ${finalUrl}`);
      }
    } catch (error) {
      console.error('Error opening link:', error);
    }
  };

  if (!links || links.length === 0) {
    return null;
  }

  return (
    <View style={[styles.container, style]}>
      <Text style={styles.label}>{label}</Text>
      <View style={styles.linksContainer}>
        {links.map((link, index) => (
          <TouchableOpacity
            key={`${link.url}_${index}`}
            style={styles.linkItem}
            onPress={() => handleLinkPress(link.url)}
          >
            <MaterialCommunityIcons
              name="link-variant"
              size={18}
              color={colors.primary}
            />
            <Text style={styles.linkText}>{link.label}</Text>
            <MaterialCommunityIcons
              name="open-in-new"
              size={14}
              color={colors.textSecondary}
            />
          </TouchableOpacity>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: spacing.md,
    padding: spacing.md,
    backgroundColor: colors.gray100,
    borderRadius: 8,
    borderLeftWidth: 4,
    borderLeftColor: colors.primary,
  },
  label: {
    ...typography.body1,
    fontWeight: '600',
    color: colors.text,
    marginBottom: spacing.sm,
  },
  linksContainer: {
    gap: spacing.sm,
  },
  linkItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: spacing.xs,
    gap: spacing.sm,
  },
  linkText: {
    ...typography.body2,
    color: colors.primary,
    flex: 1,
    textDecorationLine: 'underline',
  },
});

export default HelpfulLinksDisplay;
